import axios from 'axios';

const searchImages = async (term) => {
  const response = await axios.get('https://api.unsplash.com/search/photos', {
    headers: {
      Authorization: 'Client-ID Pv0XHhw0YAbm63AUq09URkwoVGmEsSOzrdsQv59Yqbg',
    },
    params: {
      query: term,
    },
  });

  return response.data.results;
};

export default searchImages;
